<template>
  <div class="space-y-4">
    <!-- Success Header -->
    <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
      <div class="flex items-start gap-3">
        <svg
          class="h-6 w-6 text-green-600 dark:text-green-400 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div class="flex-1">
          <p class="text-sm font-medium text-green-900 dark:text-green-200">
            ¡Restaurante Creado Exitosamente!
          </p>
          <p class="text-sm text-green-700 dark:text-green-300 mt-1">
            <strong>{{ createdRestaurant.name }}</strong>
          </p>
        </div>
      </div>
    </div>

    <!-- Admin Credentials Card -->
    <div class="bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 border-2 border-indigo-300 dark:border-indigo-700 rounded-lg p-5">
      <div class="flex items-center gap-2 mb-3">
        <svg
          class="h-5 w-5 text-indigo-600 dark:text-indigo-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
        <h3 class="text-lg font-semibold text-indigo-900 dark:text-indigo-100">
          Credenciales de Administrador
        </h3>
      </div>
      
      <div class="space-y-3">
        <!-- Username -->
        <div>
          <label class="block text-xs font-medium text-indigo-700 dark:text-indigo-300 mb-1">
            Usuario:
          </label>
          <div class="flex items-center gap-2">
            <input
              :value="createdRestaurant.admin_email"
              readonly
              class="flex-1 px-3 py-2 bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-600 rounded-lg text-sm text-gray-900 dark:text-white font-mono"
            >
            <button
              type="button"
              class="px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm"
              @click="$emit('copy-to-clipboard', createdRestaurant.admin_email, 'Usuario')"
            >
              Copiar
            </button>
          </div>
        </div>

        <!-- Password -->
        <div>
          <label class="block text-xs font-medium text-indigo-700 dark:text-indigo-300 mb-1">
            Contraseña:
          </label>
          <div class="flex items-center gap-2">
            <input
              :value="restaurantCreationData.admin_password"
              readonly
              class="flex-1 px-3 py-2 bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-600 rounded-lg text-sm text-gray-900 dark:text-white font-mono"
            >
            <button
              type="button"
              class="px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm"
              @click="$emit('copy-to-clipboard', restaurantCreationData.admin_password, 'Contraseña')"
            >
              Copiar
            </button>
          </div>
        </div>

        <!-- URL -->
        <div>
          <label class="block text-xs font-medium text-indigo-700 dark:text-indigo-300 mb-1">
            URL:
          </label>
          <div class="flex items-center gap-2">
            <input
              :value="restaurantCreationData.restaurant_url"
              readonly
              class="flex-1 px-3 py-2 bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-600 rounded-lg text-sm text-gray-900 dark:text-white font-mono"
            >
            <button
              type="button"
              class="px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm"
              @click="$emit('copy-to-clipboard', restaurantCreationData.restaurant_url, 'URL')"
            >
              Copiar
            </button>
          </div>
        </div>

        <!-- Email -->
        <div>
          <label class="block text-xs font-medium text-indigo-700 dark:text-indigo-300 mb-1">
            Email:
          </label>
          <div class="flex items-center gap-2">
            <input
              :value="createdRestaurant.admin_email"
              readonly
              class="flex-1 px-3 py-2 bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-600 rounded-lg text-sm text-gray-900 dark:text-white font-mono"
            >
            <button
              type="button"
              class="px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm"
              @click="$emit('copy-to-clipboard', createdRestaurant.admin_email, 'Email')"
            >
              Copiar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Welcome Message -->
    <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <h4 class="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-3 flex items-center gap-2">
        <svg
          class="h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
        Mensaje de Bienvenida
      </h4>
      
      <div class="bg-white dark:bg-gray-800 rounded-lg p-3 mb-3">
        <p class="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">
          {{ restaurantCreationData.welcome_message }}
        </p>
      </div>

      <div class="flex gap-2">
        <button
          type="button"
          class="flex-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
          @click="$emit('copy-welcome-message')"
        >
          Copiar Mensaje de Bienvenida
        </button>
        <button
          type="button"
          class="flex-1 px-3 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm"
          @click="$emit('copy-shareable-message')"
        >
          Copiar Mensaje para Admin
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CreatedRestaurant, RestaurantCreationData } from './createRestaurantTypes';

interface Props {
  createdRestaurant: CreatedRestaurant;
  restaurantCreationData: RestaurantCreationData;
}

defineProps<Props>();

defineEmits<{
  (e: 'copy-to-clipboard', text: string, label: string): void;
  (e: 'copy-welcome-message'): void;
  (e: 'copy-shareable-message'): void;
}>();
</script>
